import CombineImages from '~/components/Image/CombineImages'
import { BadgeImage, SuperBadgePartImagesProgress } from '~/shared/types/bootcampBadge.types'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40vw' }]
interface Props {
  outlineBadgeImage: BadgeImage
  badgePartImages: SuperBadgePartImagesProgress[] // Part images should be sorted by order i.e. Bootcamp number
  badgeHeight?: number
  className?: string
  outlineBadgeClass?: string
  partBadgeClass?: string
  onClick?: () => void
  imageMediaQuery?: Array<{ screen: string; width: string }>
}

const BootcampSuperBadge = ({
  outlineBadgeImage,
  badgePartImages,
  badgeHeight = 80,
  className = '',
  outlineBadgeClass = '',
  partBadgeClass = '',
  onClick = () => {},
  imageMediaQuery = mediaQuery,
}: Props): React.ReactElement => {
  return (
    <div className={`relative ${className}`} onClick={onClick}>
      <ResponsiveImage
        alt={outlineBadgeImage.alt}
        height={badgeHeight}
        imageClassName={`relative top-0 z-0 opacity-20 ${outlineBadgeClass}`}
        imageWidths="20, 40, 80, 160, 320, 640"
        mediaQuery={imageMediaQuery}
        srcKey={outlineBadgeImage.srcKey}
      />
      {badgePartImages.length > 0 && (
        <CombineImages
          alt={badgePartImages[0].alt}
          className={`absolute top-0 ${partBadgeClass}`}
          height={badgeHeight}
          srcKeys={badgePartImages
            .filter((badgeImage) => badgeImage.bossDefeated)
            .map((badgeImage) => badgeImage.srcKey)}
        />
      )}
    </div>
  )
}

export default BootcampSuperBadge
